/**
 * Binary session-recording consent badge shared by the calendar event modal
 * and the appointment header. Green only when every client in the session
 * has a current `permitted` recording Consent (mirrors the Zoom gate).
 */
import { Badge, Tooltip, type BadgeProps } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';

export function SessionRecordingConsentBadge({
  consented,
  ...badgeProps
}: { consented: boolean } & BadgeProps): JSX.Element {
  return (
    <Tooltip
      label={consented
        ? 'Every client in this session has consented to session recording.'
        : 'One or more clients in this session have not consented to session recording. In-person recording cannot start, and Zoom auto-recording stays off.'}
      multiline
      w={320}
    >
      <Badge
        variant="light"
        color={consented ? 'green' : 'red'}
        leftSection={consented ? <IconCheck size={12} /> : <IconX size={12} />}
        {...badgeProps}
      >
        {consented ? 'Recording consent on file' : 'No recording consent'}
      </Badge>
    </Tooltip>
  );
}
